import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { UtilsService } from 'src/app/modules/shared/services';
import { PatientRegisterService } from 'src/app/screens/patient-registration/services/patient-register.service';

@Component({
  selector: 'app-connect-wearables',
  templateUrl: './connect-wearables.component.html',
  styleUrls: ['./connect-wearables.component.scss']
})
export class ConnectWearablesComponent implements OnInit {

  @Input() patientId: string;
  @Output() appleConnected = new EventEmitter();

  connectionUrl: string = '';

  connectType: string = '';

  allItemsShown = false;

  constructor(
    private patientRegistrationService: PatientRegisterService,
    private utilService: UtilsService,
  ) { }

  ngOnInit(): void {
    console.log('ewfwefwe');
    
    this.getTerraWearableModels();
  }

  // connectAndroid() {
  //   const type = 'other';
  //   this.connectType = type;
  //   this.sendConnectRequest(type);
  // }

  // connectApple() {
  //   const type = 'apple';
  //   this.connectType = type;
  //   this.sendConnectRequest(type);
  // }

  connect() {
    let type = 'other';
    if(this.selectedProvider.label === 'APPLE') {
      type = 'apple';
    }
    if(this.selectedProvider.label === 'SAMSUNG HEALTH') {
      type = 'samsung';
    }
    this.connectType = type;
    this.sendConnectRequest(type);
  }

  showAll() {
    this.allItemsShown = true;
  }

  showLess() {
    this.allItemsShown = false;
  }

  sendConnectRequest(type: string) {
    if(type === 'samsung') {
      type = 'apple'
    }
    const payload = {
      type,
      patient_id: this.patientId
    }
    this.patientRegistrationService.connectWearable(payload).subscribe(
      (res: any) => {
        console.log(res);
        if(res.status === 'success') {
          if(type === 'apple') {
            this.appleConnected.emit();
          }
          this.connectionUrl = res.url;
        }
      }, err => {
        console.log(err);
      })

  }

  CopyPopup(){
    this.utilService.showSuccessToast('Conection Link Copied Successfully'); 
  }

  copyConnectionUrl() {
    return this.connectionUrl;
  }

  providers: SelectItem[];
  providersList: any[] = [];
  models: SelectItem[];
  selectedProvider: any;
  selectedModel: any;
  selectedModelName: string;
  getTerraWearableModels() {
    this.patientRegistrationService.terraWerableModels().subscribe(
      (res: any) => {
        console.log(res);
        //this.providers = res.map(provider => ({ label: provider.provider, value: provider }));
        this.providersList = res.map(provider => ({ label: provider.provider, value: provider, image: provider.provider_image, models: provider.models }));
      }, err => {
        console.log(err);
      }
    );
  }

  selectProvider(provider) {
    this.selectedModel = null;
    this.connectType = '';
    this.selectedProvider = provider;
    this.onProviderChange();
  }
  
  onProviderChange() {
    if (this.selectedProvider && this.selectedProvider.models) {
      this.models = this.selectedProvider.models.map(model => ({ label: model.model_name, value: model }));
    } else {
      console.error('selectedProvider or selectedProvider.models is undefined');
    }
  }

  onModelChange(model) {
    this.selectedModel = model.value;
    this.selectedModelName = model.label;
  }

  getKeys(obj: any): string[] {
    const result = Object.keys(obj);
    console.log(result);
    
    return result;
  }

  formatString(value: string): string {
    if (!value) {
      return value;
    }
  
    // Replace underscores with spaces and convert to lowercase
    value = value.replace(/_/g, ' ').toLowerCase();
  
    // Convert the first character of each word to uppercase
    return value.replace(/\b\w/g, l => l.toUpperCase());
  }

  extractSeries(text: string): string {
    let parts = text.split('-');
    return parts.length > 1 ? parts[1].trim() : '';
  }
  
}
